import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie } from "src/utils/cookieUtil";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";
import { UserVo } from "src/vo/userVo";

const serverIp = process.env.REACT_APP_SERVER_IP;

// 1-1. initial state 객체 생성
const initialState: UserVo = {};

export const userAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  tagTypes: ["USER"],
  reducerPath: "userAPI",
  endpoints: (builder) => ({
    // 유저 ID 조회
    tokenRefresh: builder.query({
      query: (re_token) => ({
        url: serverIp + "/auth/access",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + re_token,
          Accept: "*/*, text/plain",
        },
      }),
    }),
    selectUser: builder.query({
      query: (user_id) => ({
        url: `users/${user_id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      // transformResponse: (response: any) => response.data,
    }),
    updateUser: builder.mutation({
      query: ({ userId, data }) => {
        const isFormData = data instanceof FormData;
        return {
          url: `/users/${userId}`,
          method: "PUT",
          headers: isFormData 
            ? {
                Accept: "*/*, text/plain",
              }
            : {
                "Content-Type": "application/json",
                Accept: "*/*, text/plain",
              },
          body: data,
        };
      },
    }),
    // 업체 조회
    selectCompany: builder.query({
      query: (data) => ({
        url: `/users/search/company`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: data,
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 매장 조회
    selectStore: builder.query({
      query: (data) => ({
        url: `users/search/store`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: data,
      }),
      transformResponse: (response: any) => response.data,
    }),
    addGroupName: builder.mutation({
      query: (data) => ({
        url: `/users/group`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    addGroupStore: builder.mutation({
      query: (data) => ({
        url: `/users/group/store`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    updateGroupStore: builder.mutation({
      query: ({ group_part_idx, data }) => ({
        url: `/users/group/${group_part_idx}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // 그룹명 조회
    selectGroup: builder.query({
      query: ({ userId, type }) => ({
        url: `/users/${userId}/group/${type}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 그룹 아이디 조회
    selectGroupStore: builder.query({
      query: ({ groupId, queryString }) => ({
        url: `/users/group/${groupId}/store`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: queryString,
      }),
      transformResponse: (response: any) => response.data,
    }),
    // 그룹의 매장 삭제
    deleteGroupStore: builder.mutation({
      query: (data) => ({
        url: `/users/group/store`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // 그룹 삭제
    deleteGroup: builder.mutation({
      query: ({ groupId }) => ({
        url: `/users/group/${groupId}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // 매장별 프로필 공지 이행 요약정보
    executeSummary: builder.query({
      query: ({ user_id, queryString }) => ({
        url: `notice/profile/rate/${user_id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: queryString,
      }),
    }),
    // 매장별 프로필 공지 이행 요약정보
    executeHistory: builder.query({
      query: ({ user_id, queryString }) => ({
        url: `notice/profile/notice-history/${user_id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: queryString,
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const {
  useSelectUserQuery,
  useUpdateUserMutation,
  useSelectCompanyQuery,
  useSelectStoreQuery,
  useAddGroupNameMutation,
  useAddGroupStoreMutation,
  useUpdateGroupStoreMutation,
  useSelectGroupQuery,
  useSelectGroupStoreQuery,
  useDeleteGroupMutation,
  useDeleteGroupStoreMutation,
  useExecuteSummaryQuery,
  useExecuteHistoryQuery,
} = userAPI;
